<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/dashboard">Home</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <a class="page-head__crumb" routerLink="/admin/dashboard">Admin</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <a class="page-head__crumb" routerLink="/admin/system-status">System status</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page">Logs</span>
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">System logs</h1>
        <p class="page-head__subtitle">
          Recent WARNING and ERROR entries from the application log, newest first. Use this to debug
          issues without shell access. Search for the reference in an error message (e.g. “Ref: 1a2b3c4d”) to see what happened on that request.
        </p>
      </div>

      <div class="page-head__actions">
        <mat-form-field appearance="outline" class="logs-header__search">
          <mat-label>Search</mat-label>
          <input
            #searchBox
            matInput
            placeholder="Reference or text"
            [value]="search()"
            (keyup.enter)="onSearch(searchBox.value)"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="logs-header__level">
          <mat-label>Level</mat-label>
          <mat-select
            [value]="level()"
            (selectionChange)="onLevelChange($event.value)"
            [disabled]="loading()"
          >
            <mat-option value="">All levels</mat-option>
            @for (l of levels(); track l) {
              <mat-option [value]="l">{{ l }} and above</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button
          mat-stroked-button
          type="button"
          (click)="onSearch(searchBox.value)"
          [disabled]="loading()"
        >
          Refresh
        </button>
      </div>
    </div>
  </header>

  @if (loading()) {
    <ul class="log-list" aria-label="Loading logs" aria-busy="true">
      @for (r of [1, 2, 3, 4, 5, 6, 7, 8]; track r) {
        <li class="log-entry">
          <div class="log-entry__head">
            <span class="sg-skeleton sg-skeleton--text" style="width: 60px"></span>
            <span class="sg-skeleton sg-skeleton--text" style="width: 140px"></span>
            <span class="sg-skeleton sg-skeleton--text" style="width: 180px"></span>
          </div>
          <span
            class="sg-skeleton sg-skeleton--text"
            style="width: 90%; margin-top: var(--space-2)"
          ></span>
        </li>
      }
    </ul>
  } @else if (error()) {
    <div class="sg-empty sg-empty--error sg-empty--bordered">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load logs</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button mat-stroked-button type="button" (click)="load()">
        <app-icon name="refresh" [size]="18" /> Try again
      </button>
    </div>
  } @else if (data(); as d) {
    @if (!d.file_present) {
      <div class="sg-empty sg-empty--bordered">
        <app-icon name="file-text" [size]="40" />
        <p class="sg-empty__title">No log file yet</p>
        <p class="sg-empty__desc">
          Nothing has been logged at WARNING or above since the server last started.
        </p>
      </div>
    } @else if (d.results.length === 0) {
      <div class="sg-empty sg-empty--bordered">
        <app-icon name="search" [size]="40" />
        <p class="sg-empty__title">No results</p>
        <p class="sg-empty__desc">No log entries match the current filter.</p>
        <button mat-stroked-button type="button" (click)="onLevelChange('')">Clear filter</button>
      </div>
    } @else {
      <ul class="log-list">
        @for (entry of d.results; track $index) {
          <li
            class="log-entry"
            [class.log-entry--warning]="entry.level === 'WARNING'"
            [class.log-entry--error]="entry.level === 'ERROR' || entry.level === 'CRITICAL'"
          >
            <div class="log-entry__head">
              <span class="log-entry__level">{{ entry.level }}</span>
              <span class="log-entry__timestamp">{{ entry.timestamp }}</span>
              <span class="log-entry__logger">{{ entry.logger }}</span>
            </div>
            <pre class="log-entry__message">{{ entry.message }}</pre>
          </li>
        }
      </ul>

      @if (d.num_pages > 1) {
        <div class="log-pager">
          <button
            mat-stroked-button
            type="button"
            (click)="previousPage()"
            [disabled]="!d.has_previous"
          >
            Previous
          </button>
          <span class="log-pager__status">
            Page {{ d.page }} of {{ d.num_pages }} · {{ d.count }} entries
          </span>
          <button mat-stroked-button type="button" (click)="nextPage()" [disabled]="!d.has_next">
            Next
          </button>
        </div>
      }
    }
  }
</div>
